import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "input-col center-y" }
const _hoisted_2 = ["min", "max", "step", "disabled"]

import { InputCustomEvent, IonInput } from "@ionic/vue";
import { computed, ref, watch, onMounted, onBeforeUnmount } from "vue";

import ButtonMinus from "@/components/button/ButtonMinus.vue";
import ButtonPlus from "@/components/button/ButtonPlus.vue";

import { INITIAL_TIMER, TIMER_MIN, TIMER_SUBSTRACTION } from "@/assets/variables";

import { ION_VARIANT } from "@/types/enum/ionicEnum";
import { InputAmountPerformanceProps } from "@/types/props";
import { InputAmountEmits } from "@/types/emits";
import { appResult } from "@/functions/enviroment";


export default /*@__PURE__*/_defineComponent({
  __name: 'InputAmountPerformance',
  props: {
    modelValue: {},
    amountStep: { default: 1 },
    min: { default: 0 },
    max: {},
    disabled: { type: Boolean },
    directInputDisabled: { type: Boolean },
    web: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const amountInput = ref()

let intervalId: ReturnType<typeof setInterval>;
let changeTimer = INITIAL_TIMER;

let preventBlur = false

const inputValue = computed<number>({
    get: () => {
        if (props.modelValue === undefined) return 0
        return Number(props.modelValue)
    },
    set: async (value) => {
        // const convertedNumber = Number(value)
		const convertedNumber = Number(String(value).replace(/[^0-9]*/g, ''));

        if (isNaN(convertedNumber)) {
            emit('update:modelValue', props.min)
            amountInput.value.value = props.min;
            return
        }

        if (convertedNumber < props.min) {
            emit('update:modelValue', props.min)
            amountInput.value.value = props.min;
            return
        }

        if (props.max && convertedNumber > props.max) {
            emit('update:modelValue', props.max)
            amountInput.value.value = props.max;
            return
        }

        emit('update:modelValue', convertedNumber)
        emit('change', convertedNumber)
        amountInput.value.value = convertedNumber;
    },
})

const handleFocus = (event: FocusEvent) => {
    if (preventBlur) {
        preventBlur = false
        return
    }
    const target = event.target as HTMLInputElement;
    target?.blur()
}

const selectValue = (event: Event): void => {
    const target = event.target as HTMLInputElement;
    preventBlur = true
    target.select();
}

const removeInterval = () => {
    clearInterval(intervalId)
    changeTimer = INITIAL_TIMER
}

const setUpdateInterval = (modifier: 'plus' | 'minus') => {
    clearInterval(intervalId)
    changeTimer = changeTimer - TIMER_SUBSTRACTION >= TIMER_MIN ? changeTimer - TIMER_SUBSTRACTION : TIMER_MIN
    intervalId = setTimeout(() => {
        inputValue.value += modifier === 'plus' ? props.amountStep : (-1 * props.amountStep)
        setUpdateInterval(modifier)
    }, changeTimer)
}

watch(props, () => {
    if (Number(props.modelValue) < 1) removeInterval()
})

const changeValue = (modifier: 'plus' | 'minus'): void => {
    inputValue.value += modifier === 'plus' ? props.amountStep : (-1 * props.amountStep)

    setUpdateInterval(modifier)
}

onMounted(() => {
  document.addEventListener('mouseup', removeInterval)
})

onBeforeUnmount(() => {
  document.removeEventListener('mouseup', removeInterval)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card-border input-grid coral-coral-background p-2 input-amount-container ion-activatable", { web: __props.web }]),
    onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop","prevent"]))
  }, [
    _createVNode(ButtonMinus, {
      class: "round-button tint-button amount-button",
      color: _unref(ION_VARIANT).CORAL,
      onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(appResult) ? undefined : changeValue('minus')), ["stop"])),
      onMouseup: removeInterval,
      onTouchstart: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_unref(appResult) ? changeValue('minus') : undefined), ["stop"])),
      onTouchend: removeInterval,
      onContextmenu: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
    }, null, 8, ["color"]),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        ref_key: "amountInput",
        ref: amountInput,
        class: "light-light-background max-size center ion-text-center remove-padding-input amount-input amount-input-fix",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inputValue).value = $event)),
        min: props.min,
        max: __props.max,
        id: "input-amount-cart",
        step: String(__props.amountStep),
        inputmode: "numeric",
        type: "text",
        disabled: __props.directInputDisabled || __props.disabled,
        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (selectValue($event)), ["stop"])),
        onFocusin: handleFocus
      }, null, 40, _hoisted_2), [
        [
          _vModelText,
          inputValue.value,
          void 0,
          { number: true }
        ]
      ])
    ]),
    _createVNode(ButtonPlus, {
      class: "round-button tint-button amount-button",
      color: _unref(ION_VARIANT).CORAL,
      onMousedown: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_unref(appResult) ? undefined : changeValue('plus')), ["stop"])),
      onMouseup: removeInterval,
      onTouchstart: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_unref(appResult) ? changeValue('plus') : undefined), ["stop"])),
      onTouchend: removeInterval,
      onContextmenu: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["stop","prevent"]))
    }, null, 8, ["color"])
  ], 2))
}
}

})